import { useMemo } from 'react';

import { useCartContext } from '@fhs-legacy/frontend/src/state/cart';
import { centsToDollarString } from '@fhs-legacy/frontend/src/utils/index';

import { usePaymentMethodStore } from '../payment';

import { useSelectedGiftCard } from './use-selected-gift-card';

export function useGiftCardCheckoutValidation() {
  const { serverOrder } = useCartContext();
  const selectedPaymentMethod = usePaymentMethodStore(state => state.selectedPaymentMethod);
  const selectedGiftCard = useSelectedGiftCard();
  const totalCents = serverOrder?.cart?.totalCents || 0;

  return useMemo(() => {
    const errorGiftCardBalanceNotEnough =
      selectedPaymentMethod === 'giftCard' &&
      Boolean(selectedGiftCard) &&
      (!selectedGiftCard?.currentBalance || selectedGiftCard.currentBalance < totalCents);

    const giftCardDueAmountInCents = totalCents - (selectedGiftCard?.currentBalance ?? 0);

    const giftCardMissingAmount =
      errorGiftCardBalanceNotEnough && selectedGiftCard?.currentBalance !== undefined
        ? centsToDollarString(giftCardDueAmountInCents)
        : undefined;

    const showReloadGiftCardCTA = Boolean(selectedGiftCard) && Boolean(giftCardMissingAmount);

    return {
      errorGiftCardBalanceNotEnough,
      giftCardMissingAmount,
      showReloadGiftCardCTA,
      selectedGiftCard,
      giftCardDueAmountInCents,
    };
  }, [selectedGiftCard, totalCents, selectedPaymentMethod]);
}
